import { Link } from '@ctw/shared/components/link';
import { DOCUMENT_VIEWER_LINK_TEST_ID } from '@ctw/shared/test/ids';
import { isParsedTextNode, uniqueIdentifierForNode } from '@ctw/shared/utils/cda/helpers';
import type { CdaParsedHtmlElementNode } from '@ctw/shared/utils/cda/types';
import { twx } from '@ctw/shared/utils/tailwind';
import { isEmpty } from 'lodash-es';
import { memo } from 'react';
import { ReactNodeRenderer } from './react-node-renderer';

interface ReactLinkRendererProps {
  id: string;
  link: CdaParsedHtmlElementNode;
}

export const ReactLinkRenderer = memo(({ id, link }: ReactLinkRendererProps) => {
  const href = link.attributes.href?.trim() ?? '';

  if (isEmpty(href)) {
    return <></>;
  }

  const childrenIsSoloTextElement =
    link.childNodes.length === 1 && isParsedTextNode(link.childNodes[0]);

  return (
    <Link
      key={id}
      id={id}
      href={href}
      dataTestId={DOCUMENT_VIEWER_LINK_TEST_ID}
      dataSearchIndex={link.searchIndexId ?? undefined}
      className={twx(link.styles.className)}
    >
      {childrenIsSoloTextElement &&
        isParsedTextNode(link.childNodes[0]) &&
        link.childNodes[0].textContent}
      {!childrenIsSoloTextElement &&
        link.childNodes.map((child, index) => {
          const linkChildIdentifier = uniqueIdentifierForNode({
            node: child,
            context: id,
            purpose: 'link-child',
            index,
          });

          return (
            <ReactNodeRenderer key={linkChildIdentifier} id={linkChildIdentifier} node={child} />
          );
        })}
    </Link>
  );
});
